export const env = {
  DEBUG: process.env.REACT_APP_STAGE === 'development',
  API_URI: process.env.REACT_APP_STAGE === 'development' ? 'https://api.dev.gravitybrain.com/1.0' : 'https://api.gravitybrain.com/1.0',
  GEOLOCATION_USER: 'pkamenev'
};
console.log('NODE_ENV = ' + process.env.REACT_APP_STAGE);